module.exports = __webpack_public_path__ + "img/2222.png";